import { Form, InputGroup } from "react-bootstrap";

const FormGroup = function FormGroup({
  controlId = null,
  error,
  label = "",
  addon,
  displayAs,
  children,
  className = "",
  text = null,
  md,
}) {
  return (
    <Form.Group controlId={controlId} as={displayAs} md={md}>
      {label && <Form.Label>{label}</Form.Label>}
      <InputGroup hasValidation className={className}>
        {addon && <InputGroup.Text>{addon}</InputGroup.Text>}
        {children}
        <Form.Control.Feedback type="invalid">
          {error?.message}
        </Form.Control.Feedback>
      </InputGroup>
      {text && <Form.Text>{text}</Form.Text>}
    </Form.Group>
  );
};

export default FormGroup;
